import styled from "../_snowpack/pkg/@emotion/styled.js";
import React, {useState} from "../_snowpack/pkg/react.js";
import Collapsible from "./collapsible.js";
import {ArrowHeadDown, ArrowHeadRight} from "./icons.js";
export default function Collapse(props) {
  const {
    header,
    children,
    hideIcon,
    collapsed: initialCollapsed = true,
    ...rest
  } = props;
  const [collapsed, setCollapsed] = useState(initialCollapsed);
  const toggle = () => setCollapsed(!collapsed);
  return /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, /* @__PURE__ */ React.createElement(Header, {
    onClick: toggle
  }, !hideIcon && /* @__PURE__ */ React.createElement(Icon, null, collapsed ? /* @__PURE__ */ React.createElement(ArrowHeadRight, null) : /* @__PURE__ */ React.createElement(ArrowHeadDown, null)), /* @__PURE__ */ React.createElement(HeaderInner, null, header)), /* @__PURE__ */ React.createElement(Inner, {
    collapsed
  }, children));
}
const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  margin-right: 7px;
  flex-shrink: 0;
`;
const Container = styled.div``;
const Header = styled.div`
  display: flex;
  cursor: pointer;
`;
const HeaderInner = styled.div`
  flex-grow: 1;
`;
const Inner = styled(Collapsible)``;
